import React, { Component } from "react";
import { GamesLayout } from "component/menu";

import { ReactComponent as FullscreenIcon } from "assets/icons/fullscreen-alt-svgrepo-com.svg";
import { ReactComponent as ExitFullscreenIcon } from "assets/icons/fullscreen-exit-alt-svgrepo-com.svg";
import { ReactComponent as SwitchDevice } from "assets/icons/switchDevice.svg";
import { ReactComponent as CashierIcon } from "assets/icons/cashInOut.svg";
import { ReactComponent as PreviousIcon } from "assets/icons/previous.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { ReactComponent as RefreshIcon } from "assets/icons/refreshIc.svg";
import { ReactComponent as InfoIcon } from "assets/icons/gameDetails.svg";

import { ReactComponent as ScreenIcon1 } from "assets/icons/screens-icon_1.svg";
import { ReactComponent as ScreenIcon2A } from "assets/icons/screens-icon_2a.svg";
import { ReactComponent as ScreenIcon2B } from "assets/icons/screens-icon_2b.svg";
import { ReactComponent as ScreenIcon3A } from "assets/icons/screens-icon_3a.svg";
import { ReactComponent as ScreenIcon3B } from "assets/icons/screens-icon_3b.svg";
import { ReactComponent as ScreenIcon3C } from "assets/icons/screens-icon_3c.svg";
import { ReactComponent as ScreenIcon3D } from "assets/icons/screens-icon_3d.svg";
import { ReactComponent as ScreenIcon4 } from "assets/icons/screens-icon_4.svg";

import translations from "translations";

import "./styles.scss";

export const GamesLayoutType = {
  LAYOUT_1: "layout_1",
  LAYOUT_2A: "layout_2a",
  LAYOUT_2B: "layout_2b",
  LAYOUT_3A: "layout_3a",
  LAYOUT_3B: "layout_3b",
  LAYOUT_3C: "layout_3c",
  LAYOUT_3D: "layout_3d",
  LAYOUT_4: "layout_4",
};

class MultiGameController extends Component {
  render() {
    return (
      <div className="multi-game-controller">
        <div className="row nopadding d-none">
          <div
            className="col-auto"
            onClick={() => {
              this.props.history.goBack();
            }}
          >
            <PreviousIcon />
          </div>

          <div className="col text-center game-num">
            <span
              className={
                this.props.multiGameLayout === GamesLayoutType.LAYOUT_1
                  ? "selected"
                  : ""
              }
              onClick={() => {
                this.props.setMultiGame(1, GamesLayoutType.LAYOUT_1);
              }}
            >
              <ScreenIcon1 />
            </span>
            <span
              className={
                this.props.multiGameLayout === GamesLayoutType.LAYOUT_2A
                  ? "selected"
                  : ""
              }
              onClick={() => {
                this.props.setMultiGame(2, GamesLayoutType.LAYOUT_2A);
              }}
            >
              <ScreenIcon2A />
            </span>
            <span
              className={
                this.props.multiGameLayout === GamesLayoutType.LAYOUT_2B
                  ? "selected"
                  : ""
              }
              onClick={() => {
                this.props.setMultiGame(2, GamesLayoutType.LAYOUT_2B);
              }}
            >
              <ScreenIcon2B />
            </span>
            <span
              className={
                this.props.multiGameLayout === GamesLayoutType.LAYOUT_3A
                  ? "selected"
                  : ""
              }
              onClick={() => {
                this.props.setMultiGame(3, GamesLayoutType.LAYOUT_3A);
              }}
            >
              <ScreenIcon3A />
            </span>
            <span
              className={
                this.props.multiGameLayout === GamesLayoutType.LAYOUT_3B
                  ? "selected"
                  : ""
              }
              onClick={() => {
                this.props.setMultiGame(3, GamesLayoutType.LAYOUT_3B);
              }}
            >
              <ScreenIcon3B />
            </span>
            <span
              className={
                this.props.multiGameLayout === GamesLayoutType.LAYOUT_3C
                  ? "selected"
                  : ""
              }
              onClick={() => {
                this.props.setMultiGame(3, GamesLayoutType.LAYOUT_3C);
              }}
            >
              <ScreenIcon3C />
            </span>
            <span
              className={
                this.props.multiGameLayout === GamesLayoutType.LAYOUT_3D
                  ? "selected"
                  : ""
              }
              onClick={() => {
                this.props.setMultiGame(3, GamesLayoutType.LAYOUT_3D);
              }}
            >
              <ScreenIcon3D />
            </span>
            <span
              className={
                this.props.multiGameLayout === GamesLayoutType.LAYOUT_4
                  ? "selected"
                  : ""
              }
              onClick={() => {
                this.props.setMultiGame(4, GamesLayoutType.LAYOUT_4);
              }}
            >
              <ScreenIcon4 />
            </span>
          </div>

          {this.props.showInfo && (
            <div
              className="col-auto info"
              title={translations("gameInfo")}
              onClick={() => {
                this.props.toggleInfo();
              }}
            >
              <InfoIcon />
            </div>
          )}

          {this.props.showCashier && (
            <div
              className="col-auto"
              onClick={this.props.broadcastCashier}
              title={translations("cashIn")}
            >
              <CashierIcon />
            </div>
          )}
          {this.props.showSwitchDevice && this.props.multiGameCount === 1 && (
            <div
              className="col-auto switch"
              onClick={() => {
                let params = {
                  location: this.props.location,
                  target: "_self",
                };

                this.props.broadcastSwitchDevice(params, this.props.gameId);
              }}
              title={translations("switchDevice")}
            >
              <SwitchDevice />
            </div>
          )}

          {this.props.onRefreshClickHandler && this.props.multiGameCount === 1 && (
            <div
              className="col-auto refresh"
              onClick={this.props.onRefreshClickHandler}
              title={translations("refresh")}
            >
              <RefreshIcon />
            </div>
          )}

          {this.props.gameFullscreen && (
            <div
              className="col-auto"
              onClick={() => {
                this.props.onFullscreenHandler(!this.props.gameFullscreen);
              }}
              title={translations("minimize")}
            >
              <ExitFullscreenIcon />
            </div>
          )}

          {!this.props.gameFullscreen && (
            <div
              className="col-auto"
              onClick={() => {
                this.props.onFullscreenHandler(!this.props.gameFullscreen);
              }}
              title={translations("maximize")}
            >
              <FullscreenIcon />
            </div>
          )}

          <div
            className="col-auto"
            onClick={this.props.onCloseClickHandler}
            title={translations("close")}
          >
            <CloseIcon />
          </div>
        </div>
        <div className="row nopadding">
          <div className="col nopadding">
            <div className="row nopadding">
              <div
                className="col-auto icon"
                onClick={() => {
                  this.props.history.goBack();
                }}
              >
                <PreviousIcon />
              </div>
            </div>
          </div>

          <div
            className={`col-auto ${!this.props.isMultiGame ? "d-none" : ""}`}
          >
            <span>
              <GamesLayout
                setMultiGame={this.props.setMultiGame}
                multiGameLayout={this.props.multiGameLayout}
                broadcastGameMode={this.props.broadcastGameMode}
              />
            </span>
          </div>
          <div className="col nopadding">
            <div className="row nopadding">
              <div className="col" />

              {this.props.showCashier && (
                <div
                  className="col-auto icon"
                  onClick={this.props.broadcastCashier}
                  title={translations("cashIn")}
                >
                  <CashierIcon />
                </div>
              )}
              {this.props.gameFullscreen && (
                <div
                  className="col-auto icon"
                  onClick={() => {
                    this.props.onFullscreenHandler(!this.props.gameFullscreen);
                  }}
                  title={translations("minimize")}
                >
                  <ExitFullscreenIcon />
                </div>
              )}

              {!this.props.gameFullscreen && (
                <div
                  className="col-auto icon"
                  onClick={() => {
                    this.props.onFullscreenHandler(!this.props.gameFullscreen);
                  }}
                  title={translations("maximize")}
                >
                  <FullscreenIcon />
                </div>
              )}
              <span
                className="col-auto icon"
                onClick={this.props.onCloseClickHandler}
                title={translations("close")}
              >
                <CloseIcon />
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MultiGameController;
